import styled from "styled-components";

export const StyledWrapper = styled.div`
    position: relative;
    margin: auto;
`;
